import { useDispatch, useSelector } from "react-redux";
import React, { useMemo, useState, useEffect } from "react";
import _ from "lodash";
import {
    addDetectionsReviewFilter,
    removeDetectionsReviewFilter,
    addDetectionsTypeFilter,
    removeDetectionsTypeFilter,
    addDetectionConditionFilter,
    removeDetectionConditionFilter,
    setSelectedRailInspectionImage,
    setCurrentDetection,
    setCurrentInspectionMarkup
} from "../../../../redux/actions/index";
import { Button, Checkbox, Modal } from "antd";

const detectionReviewFiltersSelector = (state) => state.railInspection.detections.reviewFilters;
const detectionTypesSelector = (state) => state.railInspection.detections.types;
const detectionTypeFiltersSelector = (state) => state.railInspection.detections.typeFilters;
const railInspectionSessioIDSelector = (state) => state.railInspection.railInspectionImages.loadingInfo.sessionID;
const railInspectionConditionsSelector = (state) => state.railInspection.railInspectionConditions
const firstRailInspectionImagesSelector = (state) => _.get(state.railInspection.railInspectionImages, "data", [])
const selectedRailInspectionImageSelector = (state) => state.railInspection.selectedRailInspectionImage
const detectionsDataSelector = (state) => state.railInspection.detections.data;
const detectionConditionFilterObjectSelector = state => state.railInspection.detections.detectionConditionFilter || {};
const superAdminSelector = state => state.userDetails.userConfig.super_admin

const DetectionsFiltersModal = ({ detectionsFiltersOpen, setDetectionsFiltersOpen, setNumberOfFilters }) => {
    let dispatch = useDispatch();

    const [selectAllDetectionChecked, setSelectAllDetectionChecked] = useState(true)
    const detectionReviewFilters = useSelector(detectionReviewFiltersSelector);
    const detectionTypes = useSelector(detectionTypesSelector);
    const detectionTypeFilters = useSelector(detectionTypeFiltersSelector);
    const railInspectionConditions = useSelector(railInspectionConditionsSelector);
    const selectedRailInspection = useSelector(selectedRailInspectionImageSelector);
    const firstRailInspectionImages = useSelector(firstRailInspectionImagesSelector);
    const railInspectionSessioID = useSelector(railInspectionSessioIDSelector);
    const detectionsData = useSelector(detectionsDataSelector);
    const detectionConditionFilterObject = useSelector(detectionConditionFilterObjectSelector);
    const superAdmin = useSelector(superAdminSelector);
    const [totalNumberOfFilters, setTotalNumberOfFilters] = useState(false)
    const [filteredDetectionTypes, setFilteredDetectionTypes] = useState([])

    useEffect(() => {
        if (superAdmin) {
            setFilteredDetectionTypes(detectionTypes)
        } else {
            setFilteredDetectionTypes(_.filter(detectionTypes, type => type !== "Cracked Rail"))
            dispatch(removeDetectionsTypeFilter("Cracked Rail"))
        }
    }, [superAdmin, dispatch, detectionTypes])

    const selectDetectionReview = (detectionReview) => {
        if (_.includes(detectionReviewFilters, detectionReview)) {
            dispatch(removeDetectionsReviewFilter(detectionReview));
        } else {
            dispatch(addDetectionsReviewFilter(detectionReview));
        }
    }

    const selectDetectionType = (detectionType) => {
        if (_.includes(detectionTypeFilters, detectionType)) {
            dispatch(removeDetectionsTypeFilter(detectionType));
        } else {
            dispatch(addDetectionsTypeFilter([detectionType]));
        }
    }

    const toggleAllDetectionsType = (checked) => {
        setSelectAllDetectionChecked(checked)
        _.forEach(filteredDetectionTypes, detectionType => {
            if(checked) {
                dispatch(addDetectionsTypeFilter([detectionType]));
            } else {
                dispatch(removeDetectionsTypeFilter(detectionType));
            }
        })
    }

    useEffect(() => {
        if (detectionTypeFilters && filteredDetectionTypes) {
            if (!detectionTypeFilters.length) {
                setSelectAllDetectionChecked(false)
            }
            if (filteredDetectionTypes.length === detectionTypeFilters.length) {
                setSelectAllDetectionChecked(true)
            }
        }
    }, [filteredDetectionTypes, detectionTypeFilters])

    const detectionFilters = useMemo(() => {
        if (filteredDetectionTypes && filteredDetectionTypes.length) {
            return (
                <div className="detectionCondition">
                    <Checkbox className="detectionConditionLabel detectionReviewFilter-Checkbox-Select" key={"select-all"} 
                        checked={selectAllDetectionChecked} onChange={(e) => toggleAllDetectionsType(e.target.checked)}>
                            {selectAllDetectionChecked ? "Deselect" : "Select"} all
                    </Checkbox>
                    <div className="detectionConditionList">
                        {filteredDetectionTypes.sort().map((name, idx) => {
                            return <Checkbox
                                className="detectionReviewFilter-Checkbox"
                                key={idx}
                                checked={_.includes(detectionTypeFilters, name)}
                                onChange={() => { selectDetectionType(name) }}>
                                {name}
                            </Checkbox>
                        })}
                    </div>
                </div>
            )
        } else {
            return (
                <span>No Detections</span>
            )
        }
    }, [filteredDetectionTypes, detectionTypeFilters, selectAllDetectionChecked]);

    const toggleDetectionCondition = (checked, classType, conditionID) => {
        if (checked) {
            dispatch(addDetectionConditionFilter(classType, conditionID));
        } else {
            dispatch(removeDetectionConditionFilter(classType, conditionID));
        }
    }

    const conditionFilters = useMemo(() => {
        let filterCount = 0
        const isChecked = (name, condition) => {
            return detectionConditionFilterObject[name] ? detectionConditionFilterObject[name].includes(condition.id) : false;
        }

        const isDisabled = (className) => {
            return !detectionTypeFilters.includes(className)
        }

        let conditionTypesPerSession = {};

        // check which condition types in that session
        if (railInspectionSessioID) {
            conditionTypesPerSession = _.groupBy(detectionsData, "name")
        }

        const groupedConditions = _.groupBy(railInspectionConditions, "class")
        let conditionsPerSession = _.groupBy(_.find(groupedConditions, (name, collection) => conditionTypesPerSession[collection]), "class")

        const renderedGroupedConditions = _.map(conditionsPerSession, (conditions, name) => {
            let _conditions = _.cloneDeep(conditions)
            _conditions.push({id: null, class: name, description: "None"})
            _conditions =  _.sortBy(_conditions, ["description"])
            return <div className="detectionCondition">
                <span className="detectionConditionLabel">{name}</span>
                <div className="detectionConditionList">
                    {_.map(_conditions, condition => {
                        if (!isDisabled(name) && isChecked(name, condition)) {
                            filterCount += 1;
                        }
                        return <Checkbox className="detectionReviewFilter-Checkbox" key={condition.id} disabled={isDisabled(name)} checked={isChecked(name, condition)}
                            onChange={(e) => toggleDetectionCondition(e.target.checked, name, condition.id)}>{condition.description}
                        </Checkbox>
                    })}
                </div>
            </div>
        })
        const filtersSum = filterCount + detectionTypeFilters.length + detectionReviewFilters.length;

        // if image position not moved on big sroller (no red arrow present) setTotalNumberOfFilters
        if (filtersSum !== 2 && !selectedRailInspection.timestamp && firstRailInspectionImages.length > 0 && !totalNumberOfFilters) {
            setTotalNumberOfFilters(filtersSum)
        }
        setNumberOfFilters(filtersSum)
        return renderedGroupedConditions;

    }, [railInspectionConditions, detectionConditionFilterObject, detectionTypeFilters, selectedRailInspection, detectionReviewFilters, firstRailInspectionImages, totalNumberOfFilters])


    // if filters changed in modal and inspection image is NOT selected, select first image so the nearby detections are displaed in modal 
    useEffect(() => {
        if (totalNumberOfFilters && !selectedRailInspection.timestamp && firstRailInspectionImages.length > 0) {
            dispatch(setSelectedRailInspectionImage(0, firstRailInspectionImages[0], false));
            dispatch(setCurrentDetection(null));
            dispatch(setCurrentInspectionMarkup(null, null))            
        }
    }, [selectedRailInspection, firstRailInspectionImages, totalNumberOfFilters])
    

    return (
        <Modal
            className="RailInsectionFilterModal"
            title="Detections Filters"
            visible={detectionsFiltersOpen}
            onOk={() => {
                setDetectionsFiltersOpen(false)
            }}
            onCancel={() => {
                setDetectionsFiltersOpen(false)
            }}
            footer={[
                <Button type="primary" onClick={() => {
                    setDetectionsFiltersOpen(false)
                }}>
                    Close
                </Button>
            ]}>
            <div className="MarkerThresholdPopup">
                <div className="detectionReviewRow">
                    <h3>Review Status</h3>
                    <div className="detectionReviewFilter">
                        <Checkbox className="detectionReviewFilter-Checkbox" key={1} checked={_.includes(detectionReviewFilters, 1)}
                            onChange={() => {
                                selectDetectionReview(1)
                            }}>Verified</Checkbox>
                        <Checkbox className="detectionReviewFilter-Checkbox" key={2} checked={_.includes(detectionReviewFilters, 2)}
                            onChange={() => {
                                selectDetectionReview(2)
                            }}>Verified & Hidden</Checkbox>
                        <Checkbox className="detectionReviewFilter-Checkbox" key={0} checked={_.includes(detectionReviewFilters, 0)}
                            onChange={() => {
                                selectDetectionReview(0)
                            }}>Needs Review</Checkbox>
                        <Checkbox className="detectionReviewFilter-Checkbox" key={3} checked={_.includes(detectionReviewFilters, 3)}
                            onChange={() => {
                                selectDetectionReview(3)
                            }}>Rejected</Checkbox>
                    </div>
                </div>

                <div className="detectionReviewCondition">
                    <h3>Detection Type</h3>
                    {detectionFilters}
                </div>

                {Object.keys(conditionFilters).length > 0 &&
                    <div className="detectionReviewCondition">
                        <h3>Conditions Filters</h3>
                        {conditionFilters}
                    </div>
                }
            </div>
        </Modal>
    )
}

export default DetectionsFiltersModal;